import React from "react";

const LoginPrompt = ({ onUserLogin }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-12">
      <div className="max-w-md w-full bg-gray-50 shadow-md rounded-xl p-8">
        <h2 className="text-xl font-semibold text-center mb-6 text-gray-800">
          Almost there — log in to see your result
        </h2>

        {/* Replace this with your actual login form */}
        <button
          onClick={onUserLogin}
          className="w-full py-3 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-full"
        >
          Log In
        </button>
      </div>
    </div>
  );
};

export default LoginPrompt;